/**
 * @generated SignedSource<<e8e47da56be366b15e6bacc3670e119e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type CalendarSource = "google" | "internal" | "office365";
import { FragmentRefs } from "relay-runtime";
export type EventFilters_viewer$data = {
  readonly calendars: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly source: CalendarSource;
      };
    }>;
  };
  readonly user: {
    readonly eventFilters: {
      readonly filterKeywords: ReadonlyArray<string | null>;
      readonly includeAllDay: boolean;
      readonly includeCancelled: boolean;
      readonly includeDeclined: boolean;
      readonly includeFocusTime: boolean;
      readonly includeHidden: boolean;
      readonly includeOutOfOffice: boolean;
      readonly includePersonalMeetings: boolean;
    } | null;
    readonly internalAttributes: {
      readonly dateConfigured: string | null;
    } | null;
  };
  readonly " $fragmentType": "EventFilters_viewer";
};
export type EventFilters_viewer$key = {
  readonly " $data"?: EventFilters_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventFilters_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventFilters_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserInternalAttributes",
          "kind": "LinkedField",
          "name": "internalAttributes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "dateConfigured",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UserEventFiltersNode",
          "kind": "LinkedField",
          "name": "eventFilters",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "includeCancelled",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "includeHidden",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "includeDeclined",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "includeAllDay",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "includeOutOfOffice",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "includeFocusTime",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "includePersonalMeetings",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "filterKeywords",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CalendarConnection",
      "kind": "LinkedField",
      "name": "calendars",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CalendarEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Calendar",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "source",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "8f6087e00c37bcc2b5ec4452753b0fa6";

export default node;
